var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[(_vm.verify)?_c('router-view'):_c('Spin',{attrs:{"fix":""}},[_c('Icon',{staticClass:"rotate",attrs:{"type":"ios-loading","size":"28"}}),_c('div',[_vm._v("加载中...")])],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }